import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/overview.css";

function OverviewVideo360() {
  const navigate = useNavigate();
  const [hoveredHotspot, setHoveredHotspot] = useState(null);
  const [currentVideo, setCurrentVideo] = useState("/videos/can-tho.mp4");
  const [showDigitalCenters, setShowDigitalCenters] = useState(false);

  const hotspots = [
    {
      label: "Đồng Tháp",
      route: "/dong-thap",
      logo: "/logos/dongthap.png",
      caption: "Đồng Tháp",
      video: "/videos/dong-thap.mp4",
    },
    {
      label: "An Giang",
      route: "/an-giang",
      logo: "/logos/angiang.png",
      caption: "An Giang",
      video: "/videos/an-giang.mp4",
    },
    {
      label: "Cần Thơ",
      route: "/can-tho",
      logo: "/logos/cantho.png",
      caption: "Cần Thơ",
      video: "/videos/can-tho.mp4",
    },
    {
      label: "Vĩnh Long",
      route: "/vinh-long",
      logo: "/logos/vinhlong.png",
      caption: "Vĩnh Long",
      video: "/videos/vinh-long.mp4",
    },
    {
      label: "Cà Mau",
      route: "/ca-mau",
      logo: "/logos/camau.png",
      caption: "Cà Mau",
      video: "/videos/ca-mau.mp4",
    },
  ];

  const digitalCenters = [
    {
      label: "Q.lý hồ sơ",
      route: "/center/ql-ho-so",
      thumb: "/thumbs/ql-ho-so.jpg",
    },
    {
      label: "Truy xuất Ng.gốc",
      route: "/center/truy-xuat-ng-goc",
      thumb: "/thumbs/truy-xuat-ng-goc.jpg",
    },
    {
      label: "Tìm kiếm N.cao",
      route: "/center/tim-kiem-n-cao",
      thumb: "/thumbs/tim-kiem-n-cao.jpg",
    },
    {
      label: "Đ.giá & P.hồi",
      route: "/center/danh-gia-phan-hoi",
      thumb: "/thumbs/danh-gia-phan-hoi.jpg",
    },
    {
      label: "B.cáo & P.tích",
      route: "/center/bao-cao-phan-tich",
      thumb: "/thumbs/bao-cao-phan-tich.jpg",
    },
    {
      label: "Q.lý S.phẩm & D.vụ",
      route: "/center/ql-san-pham-dich-vu",
      thumb: "/thumbs/ql-san-pham-dich-vu.jpg",
    },
    {
      label: "Q.lý C.chỉ",
      route: "/center/ql-chung-chi",
      thumb: "/thumbs/ql-chung-chi.jpg",
    },
    {
      label: "K.nối & G.dịch",
      route: "/center/ket-noi-giao-dich",
      thumb: "/thumbs/ket-noi-giao-dich.jpg",
    },
    {
      label: "Đơn hàng & T.toán",
      route: "/center/don-hang-thanh-toan",
      thumb: "/thumbs/don-hang-thanh-toan.jpg",
    },
    {
      label: "Tích hợp & API mở",
      route: "/center/tich-hop-api-mo",
      thumb: "/thumbs/tich-hop-api-mo.jpg",
    },
  ];

  const handleHover = (spot) => {
    setHoveredHotspot(spot);
    setCurrentVideo(spot.video);
  };

  const handleLeave = () => {
    const defaultSpot = hotspots.find((s) => s.label === "Cần Thơ");
    setHoveredHotspot(null);
    setCurrentVideo(defaultSpot.video);
  };

  return (
    <div className="overview">
      {/* 🔥 Multiple videos layered */}
      <div className="overview__videos">
        {hotspots.map((spot, idx) => (
          <video
            key={idx}
            className={
              "overview__video" +
              (currentVideo === spot.video ? " overview__video--active" : "")
            }
            src={spot.video}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          />
        ))}
      </div>

      <div className="overview__logo">
        <img
          src={hoveredHotspot ? hoveredHotspot.logo : "/logos/cantho.png"}
          alt={hoveredHotspot ? hoveredHotspot.label : "Cần Thơ"}
        />
        <div className="overview__logo-caption">
          {hoveredHotspot ? hoveredHotspot.caption : "Cần Thơ"}
        </div>
      </div>

      <div className="overview__hotspot-row">
        {hotspots.map((spot, idx) => (
          <div
            key={idx}
            className={
              "overview__hotspot" +
              (spot.label === "Cần Thơ" && !hoveredHotspot
                ? " overview__hotspot--active"
                : "")
            }
            onClick={() => navigate(spot.route)}
            onMouseEnter={() => handleHover(spot)}
            onMouseLeave={handleLeave}
          >
            <span
              className={
                "overview__hotspot-label" +
                (idx === 2 || idx === hotspots.length - 1
                  ? " overview__hotspot-label--small"
                  : "")
              }
            >
              {spot.label}
            </span>
          </div>
        ))}
      </div>

      <div className="overview__digital-center">
        <h2
          className="overview__digital-title"
          onClick={() => setShowDigitalCenters(!showDigitalCenters)}
        >
          TRUNG TÂM CHUYỂN ĐỔI SỐ NÔNG NGHIỆP & MÔI TRƯỜNG
        </h2>

        <div
          className={
            "overview__digital-scroll" +
            (showDigitalCenters ? "" : " overview__digital-scroll--hidden")
          }
        >
          {digitalCenters.map((center, idx) => (
            <div
              key={idx}
              className="overview__digital-item"
              onClick={() => navigate(center.route)}
            >
              <img
                src={center.thumb}
                alt={center.label}
                title={center.label}
              />
              <div className="overview__digital-label">{center.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OverviewVideo360;
